import { Box } from '@bridebook/ui';
import componentStyles from '@bridebook/web/components/bbcommon/animations/background-stars-animation.style';

export const BackgroundStarsAnimation = () => {
  const styles = componentStyles();
  return (
    <Box style={styles.wrapper}>
      <Box style={styles.stars} />
    </Box>
  );
};
